module.exports = __webpack_public_path__ + "static/media/ics-logo.a87d54de.png";